import React from 'react';
import PropTypes from 'prop-types';

import { useConfig } from '../../../../../providers/ConfigProvider';
import Button from '../../../../Button';
import DismissAction from '../DismissAction';

import styles from '../../GlobalBanner.module.scss';
import secondaryStyles from './BankAccountLoginExpired.module.scss';

const BankAccountLoginExpired = ({ bannerId }) => {
  const { PRIVATE_BASE_PATH } = useConfig();

  return (
    <div className={styles['gb-style-danger']}>
      <div className={secondaryStyles.content}>
        Your rent payment method has expired. Please log in to reconnect.
        <Button
          variant="ghost"
          small
          className={secondaryStyles.button}
          to={`${PRIVATE_BASE_PATH}settings/payment-methods`}
        >
          Log in
        </Button>
      </div>
      <DismissAction bannerId={bannerId} />
    </div>
  );
};

BankAccountLoginExpired.propTypes = {
  bannerId: PropTypes.string.isRequired,
};

export default BankAccountLoginExpired;
